import { IconButton, Tooltip } from "@kaltura/ds-react-components";
import { Chat24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { useSidebarLayoutContext } from "@kaltura/ds-react-layouts";

/**
 * Comments button that opens C&C comments tab when clicking
 */
export const CncComments = () => {
    const sendButtonAnalytics = useButtonAnalytics();
    const sidebarLayout = useSidebarLayoutContext();

    const onButtonClick = () => {
        sendButtonAnalytics("Media - Go to C&C comments", ButtonClickAnalyticsType.NAVIGATE);

        sidebarLayout.setActiveButtonId("cnc");
        sidebarLayout.setIsOpened(true);

        // TODO: jump to the comments tab within C&C (API is not ready yet)
    };

    return (
        <Tooltip title={translate("Show comments")}>
            <IconButton variant={"borderless"} size={"medium"} color={"secondary"} onClick={onButtonClick}>
                <Chat24Icon />
            </IconButton>
        </Tooltip>
    );
};
